import { AbstractControl } from '@angular/forms';
import trim from 'lodash-es/trim';
import indexOf from 'lodash-es/indexOf';

export function caseNumberValidator(control: AbstractControl) {
    let value = trim(control.value);
    // invalid if caseNumber contains space
    if ( value != null && indexOf(value, ' ') > 0) {
        return { "invalidDate": true };
    }
    return true;
}